import React, { Suspense } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { LinearProgress } from "@mui/material";
import TopBar from "./TopBar";
import { Outlet } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    "@media all and (-ms-high-contrast:none)": {
      height: 0, // IE11 fix
    },
  },
  content: {
    paddingTop: 64,
    flexGrow: 1,
    maxWidth: "100%",
    overflowX: "hidden",
  },
}));

function Detail({ route }) {
  const classes = useStyles();

  return (
    <>
      <TopBar />
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<LinearProgress />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </>
  );
}

Detail.propTypes = {
  route: PropTypes.object,
};

export default Detail;
